module.exports = "/_next/static/media/d79810201844396026f9f116cf7918ac.png";